<div>
  <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.manage.move_job' | translate }}"
    [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

  <div>
    <!-- <div class="row margin-top-8">
      <div class="col-md-3 label">
        {{ "bikeshop.modal.update_job_card.job_card.select_a_shop" | translate }}:
      </div>
      <div class="col-md-9 value">
        <p-dropdown [options]="shopList" [(ngModel)]="NewPartnerID" (onChange)="shopSelected()"></p-dropdown>
      </div>
    </div> -->
    <div>
      <hub-dropdown [options]="shopList" [(ngModel)]="NewPartnerID"
        [label]="'bikeshop.modal.update_job_card.job_card.select_a_shop' | translate"
        [disabled]="shopList && shopList.length===0" (selectionChange)="shopSelected()"></hub-dropdown>
    </div>
    <div class="margin-top-16">
      <hub-dropdown [options]="technicianList" [(ngModel)]="NewTechnicianID"
        [label]="'bikeshop.modal.update_job_card.job_card.select_a_technician' | translate"
        [disabled]="technicianList && technicianList.length===0"></hub-dropdown>
    </div>
    <div class="margin-top-16">
      <div class="jobcard-label" [ngStyle]="{'opacity': serviceTypes.length===0 ? '0.5': '1'}">{{
        'bikeshop.modal.update_job_card.job_card.select_serviceTypes' | translate }}</div>
      <p-multiSelect [options]="serviceTypes" [(ngModel)]="selectedServiceTypes" [optionLabel]="'label'"
        [optionValue]="'value'" [filter]="true" [showHeader]="true" [showToggleAll]="false"
        [disabled]="serviceTypes.length===0">
      </p-multiSelect>
    </div>
  </div>
</div>

<div class="modal-footer-container">
  <div class="button-container">
    <hub-button [text]="'general.cancel' | translate" (buttonClick)="cancel()" [disabled]=" movingJobcard"
      [style]="'outline'" [size]="'xl'"></hub-button>
    <hub-button [text]="'bikeshop.modal.update_job_card.job_card.move_jobcard' | translate"
      (buttonClick)="moveJobCard()" [disabled]="!validateForm() || movingJobcard" [loading]="movingJobcard"
      [style]="'secondary'" [size]="'xl'"></hub-button>
  </div>
</div>